import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MessageComposeService } from '../../service/message-compose.service';
import { NgForm } from '@angular/forms';
import { SelectItem } from 'primeng/api';
import { Message } from 'primeng/components/common/api';
import { MessageService } from 'primeng/components/common/messageservice';
import { Router } from '@angular/router';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';

@Component({
  selector: 'message-view',
  templateUrl: './message-view.component.html',
  styleUrls: ['./message-view.component.css']
})
export class MessageViewComponent implements OnInit {
  
  message: string = '';
  msgs: Message[] = [];

  data: any = null;

  constructor(public route: ActivatedRoute, public dataService: MessageComposeService, public router: Router) {
    
    

  }

  

  ngOnInit() {
    this.getMessage();
  }

  getMessage() {
    let m = this.route.snapshot.queryParamMap.get('m');
    let g = this.route.snapshot.queryParamMap.get('g');

    let vm = {m: m, g: g};

    this.dataService.getMessage(vm).subscribe(result => {
      this.data = result;
    }, 
    (err: HttpErrorResponse) => {
      this.showMessage('error', '', 'תקלה באחזור הודעה');
    });

  }

  downloadAttachment(attachment) {
    let m = this.route.snapshot.queryParamMap.get('m');
    let g = this.route.snapshot.queryParamMap.get('g');

    let vm = {m: m, g: g, c: this.data.Code, f: attachment.Name};

    try {
        this.dataService.downloadAttachment(vm).subscribe(result => {
          window.URL.createObjectURL(new Blob([result], { type: 'application/octet-stream' }));
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(result, attachment.Name);
          }
          let url = window.URL.createObjectURL(result)
          let link = document.createElement('a');
          link.href = url;
          link.download = `${attachment.Name}`;
          link.click();
        }, 
        (err: HttpErrorResponse) => {
          this.showMessage('error', '', 'תקלה בהורדת קובץ');
        });
    } catch (error) {
      this.showMessage('error', '', 'תקלה בהורדת הקובץ');
    }




  }

  // downloadAttachmentGet(attachment) {
  //   let m = this.route.snapshot.paramMap.get('m');
  //   let g = this.route.snapshot.paramMap.get('g');

  //   let vm = {m: m, g: g, c: this.data.Code, f: attachment.Name};

  //   try {
  //       this.dataService.downloadAttachmentGet(vm).subscribe(result => {
  //         window.URL.createObjectURL(new Blob([result], { type: 'application/octet-stream' }));
  //         if (window.navigator && window.navigator.msSaveOrOpenBlob) {
  //           window.navigator.msSaveOrOpenBlob(result, attachment.Name);
  //         }
  //         let url = window.URL.createObjectURL(result)
  //         let link = document.createElement('a');
  //         link.href = url;
  //         link.download = `${attachment.Name}`;
  //         link.click();
  //       }, 
  //       (err: HttpErrorResponse) => {
  //         this.showMessage('error', '', 'תקלה בהורדת קובץ');
  //       });
  //   } catch (err) {
  //     // this.showErrorSpecific();
  //     this.showMessage('error', '', 'תקלה בהורדת קובץ');
  //   }




  // }


  onSubmit(f: NgForm) {
    if (f.valid) {
      
    }
  }







  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({ severity: type, summary: summaryMessage, detail: message });
  }

  showSuccess() {
    this.msgs = [];
    this.msgs.push({ severity: 'success', summary: '', detail: ' העדכון נשמר בהצלחה' });
  }

  showError() {
    this.msgs = [];
    this.msgs.push({ severity: 'error', summary: '', detail: ' שגיאה בעדכון' });
  }

  showErrorSpecific() {
    this.msgs = [];
    this.msgs.push({ severity: 'error', summary: '', detail: ' תקלה בהורדת קובץ' });
  }
}



// WEBPACK FOOTER //
// C:/MyProjects_Git/GoDocu/GoDocuMng/Client/src/app/message/message-view/message-view.component.ts